import { env } from '../lib/env'
import { logInfo, logRedirect } from './utils/sso-logger'

/** Landing path segment for Adamo Pay (mirrors `/adamo-id` in adamo-id-front-end). */
export const ADAMO_SUITE_PAY_LANDING_PATH = 'adamo-pay'

/**
 * Optional query param: Pay refresh JWT appended by the suite landing on redirect.
 */
export const SUITE_PAY_REFRESH_TOKEN_QUERY_PARAM = 'pay_rt'

export function getSuiteLandingLoginUrl(): string {
  const url = `${env.REACT_APP_ADAMO_LANDING_BASE_URL}/${ADAMO_SUITE_PAY_LANDING_PATH}?login_open=true&redirect_to=${encodeURIComponent(window.location.href)}`
  logInfo('getSuiteLandingLoginUrl', { url, redirect_to: window.location.href })
  return url
}

export function getSuiteLandingSessionExpiredUrl(): string {
  const url = `${env.REACT_APP_ADAMO_LANDING_BASE_URL}/${ADAMO_SUITE_PAY_LANDING_PATH}?session_expired=true&login_open=true&redirect_to=${encodeURIComponent(window.location.href)}`
  logInfo('getSuiteLandingSessionExpiredUrl', { url, redirect_to: window.location.href })
  return url
}

/** Suite landing user profile (same path as adamo-id `ProfileHeader` update link). */
export function getSuiteLandingProfileUrl(): string {
  const url = `${env.REACT_APP_ADAMO_LANDING_BASE_URL}/profile`
  logInfo('getSuiteLandingProfileUrl', { url })
  return url
}

/** Suite services panel — redirect when user lacks Adamo Pay product access. */
export function getSuiteMyServicesUrl(): string {
  const url = `${env.REACT_APP_ADAMO_LANDING_BASE_URL}/my-services`
  logInfo('getSuiteMyServicesUrl', { url })
  return url
}

export function redirectToSuiteMyServices(): void {
  const url = getSuiteMyServicesUrl()
  logRedirect('User lacks adamo_pay access — redirect to suite my-services', url)
  window.location.href = url
}

export function redirectToSuiteLandingProfile(): void {
  const url = getSuiteLandingProfileUrl()
  logRedirect('Open account/profile on suite landing', url)
  window.location.href = url
}
